// Idea taken from https://redux.js.org/recipes/structuring-reducers/refactoring-reducers-example#combining-reducers-by-slice
// Basically each entity (company, terminal etc.) is structured to under one reducer. So when there will be more reducers, those
// just will be added to initialState and slide reducer.

import {LOAD_COMPANIES_REQUEST, LOAD_COMPANIES_SUCCESS, LOAD_COMPANIES_FAILURE, COMPANIES_NEW_COMPANY, COMPANIES_EDIT_COMPANY, DELETE_COMPANY_REQUEST, COMPANIES_DELETE_COMPANY} from '../actions/actionTypes';
import {createReducer, updateObject} from './reducerUtilities';


const initialState = {
    companies: {
        companiesData: null,
        isLoading: false,
        hasFailed: false,
        isDeleting: false
    },
};

// Slice reducer
export const companyReducer = createReducer(initialState, {
    [LOAD_COMPANIES_REQUEST] : loadCompaniesRequest,
    [LOAD_COMPANIES_SUCCESS] : loadCompaniesSuccess,
    [LOAD_COMPANIES_FAILURE] : loadCompaniesFailure,
    [COMPANIES_NEW_COMPANY] : addCompany,
    [COMPANIES_EDIT_COMPANY] : editCompany,
    [DELETE_COMPANY_REQUEST] : deleteCompanyRequest,
    [COMPANIES_DELETE_COMPANY] : deleteCompany
});


// -----------------------------------------------------------------------
// LOAD COMPANIES
// -----------------------------------------------------------------------

// Case reducer
function loadCompaniesRequest(state, action) {
    return {...state, companies: updateObject(
        state.companies, { 
            isLoading: true 
        })};
}

// Case reducer
function loadCompaniesSuccess(state, action) {   
    return {...state, companies: updateObject(
        state.companies, { 
            companiesData: action.payload.companies, 
            isLoading: false 
        })};
}

// Case reducer
function loadCompaniesFailure(state, action) {
    return {...state, companies: updateObject(
        state.companies, { 
            companiesData: [], 
            isLoading: false, 
            hasFailed: true 
        })};
}

function addCompany(state, action) {
    return {...state, companies: updateObject(
        state.companies, { 
            companiesData: [...state.companies.companiesData, action.data]
        })};    
}

function editCompany(state, action) {
    // const id = action.data.id
    // const companyToChange = state.companies.companiesData.find(c => c.id === id)
    // const changedCompany = { ...noteToChange, important: !noteToChange.important }
    return {...state, companies: updateObject(
        state.companies, { 
            companiesData: state.companies.companiesData.map(c => c.id === action.data.id ? action.data : c)
        })}; 
}

// Case reducer
function deleteCompanyRequest(state, action) {
    return {...state, companies: updateObject(
        state.companies, { 
            isDeleting: action.data
        })};
}

function deleteCompany(state, action) {
    let newCompanies = state.companies.companiesData;
    const indx = newCompanies.findIndex(t => t.id === action.data);
    if(indx > -1) {
        newCompanies.splice(indx, 1);
    }
    return {...state, companies: updateObject(
        state.companies, {
            companiesData: newCompanies
        }
    )}
}

// -----------------------------------------------------------------------
// TODO
// -----------------------------------------------------------------------


// WEBPACK FOOTER //
// ./src/reducers/companyReducer.js